










































































































































































































































import {Component, Watch, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {isEqual, cloneDeep} from "lodash"
import draggable from "vuedraggable"
import {IContactBlock} from '@/store/modules/lib'
import ICheckContactBlock from "@/components/icons/ICheckContactBlock.vue"
import IEdit from '@/components/icons/IEdit.vue'
import IPhoneContactBlock from '@/components/icons/IPhoneContactBlock.vue'
import IDraggable from '@/components/icons/IDraggable.vue'
import IArrow from '@/components/icons/IArrow.vue'
import IPlus from '@/components/icons/IPlus.vue'
import Modal from "@/components/UI/Modal.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';

const profile = namespace('profile')
const contacts = namespace('contacts')
const alerts = namespace('alerts')
const locale = namespace('locale')

@Component({
  components: {ICheckContactBlock, IEdit, IPhoneContactBlock, draggable, IDraggable, Modal, BtnDefault, IArrow, IPlus}
})

export default class ContactBlock extends Vue {

  @profile.Getter('standCompanies') protected standCompanies: any
  @profile.Getter('plan') protected plan: any
  @contacts.Getter('contacts') protected getContacts: any
  @contacts.Getter('contactFields') protected contactFields: any
  @contacts.Getter('loading') protected loading: any
  @alerts.Getter('show') protected show: any
  @alerts.Getter('messages') protected messages: any
  @alerts.Getter('position') protected position: any

  @alerts.Mutation('setAlert') protected setAlert: any

  @contacts.Action('fetchContacts') protected fetchContacts: any
  @contacts.Action('fetchFieldsList') protected fetchFieldsList: any
  @contacts.Action('patchContacts') protected patchContacts: any

  @locale.Getter('getLocale') protected locale: any

  @Watch('contacts')
  onContactsChanged() {
    const checkedIndexes: number[] = []
    this.contacts.forEach((contact: any, contactIdx: number) => {
      if (this.DEFAULT_TYPES.includes(contact.type)) return
      contact.order = contactIdx
      if (this.CUSTOM_TYPES.includes(contact.type)) return
      const checkedContactIdx = this.normalizedContactFields.findIndex((field: any) => {
        return field.type == contact.type
      })
      if (checkedContactIdx == -1) return
      checkedIndexes.push(checkedContactIdx)
    })
    this.normalizedContactFields.forEach((field: any, fieldIdx: number) => {
      field.checked = checkedIndexes.includes(fieldIdx)
    })
  }

  @Watch('locale')
  localeFields() {
    this.fetchAndNormalizeContactFields()
    this.fetchAndNormalizeContacts()
  }
  currentStep: number = 1
  steps: number = 4
  search: string = ''
  editingField: string = ''
  currentContact: any = {}
  contacts: IContactBlock[] = []
  normalizedContactFields: { type: string, title: string, checked: boolean }[] = []
  DEFAULT_TYPES: string[] = ['firstName', 'secondName', 'email', 'site', 'link', 'phone']
  CUSTOM_TYPES: string[] = ['custom']
  modal: any = { show: false, title: '', action: () => this.$t('contactBlock.steps.1.action'), cancel: () => this.$t('contactBlock.steps.1.cancel') }
  customTitle:string = ''
  editCustom:boolean = false
  menu:boolean = false
  customModal:boolean = false

  get isValid() {
    return !this.editCustom || this.customTitle.length != 0
  }

  get searchFields() {
    if (this.search) return this.sortedFields.filter((field: any) =>
      field.title.toLowerCase().includes(this.search.toLowerCase().trim()))
    return this.sortedFields
  }

  get sortedFields() {
    this.normalizedContactFields.sort((a:any, b:any) => {
      if(a.type == 'custom') return +1
      return a.title.localeCompare(b.title);
    });
    return this.normalizedContactFields
  }

  get hasSearchMatch() {
    if (!this.search) return true
    return !!this.normalizedContactFields.find((field: any) => {
      return this.search.toLowerCase().trim() == field.title.toLowerCase()
    })
  }
  get isContactBlockChanged() {
    return !isEqual(this.contacts.map((el: any) => {
      return { title: el.title, order: el.order}
    }), this.getContacts.map((el: any) => {
      return { title: el.title, order: el.order}
    }))
  }
  get hasEditingField() {
    return this.contacts.some((field: any) => field.isEditing)
  }

  changeCustom(title:any) {
    this.customTitle = title
  }

  addCustomField() {
    if (this.hasSearchMatch) return
    this.contacts.push({
      type: 'custom',
      title: this.search.trim(),
      order: this.contacts.length,
      isEditing: false
    })
    this.search = '';
    (document.querySelector('.contacts-autocomplete_input input') as HTMLElement).focus()
    this.setAlert({
      show: true,
      messages: [this.$t('contactBlock.steps.1.notification_custom')],
    })
  }
  checkTypedField(field: any) {
    field.checked = !field.checked
    if(field.type != 'custom') {
      if (field.checked) {
        this.contacts.push({
          title: field.title,
          type: field.type,
          order: this.contacts.length,
          isEditing: false
        })
        this.contacts.map((contact:any, index:number) => contact.order = index)
      } else {
        const idx = this.contacts.findIndex((el: any) => el.type == field.type)
        if (idx != -1) this.contacts.splice(idx, 1)
      }
    }
    else {
      this.customModal = true
    }
    (document.querySelector('.contacts-autocomplete_input input') as HTMLElement).focus()
  }
  editCustomContact(contact: any) {
    this.editCustom = true
    this.customTitle = contact.title
    this.editingField = contact.title
    contact.isEditing = true
    const input = document.getElementById(`table-input${contact.order}`)!
    setTimeout(() => {
      input.focus()
    }, 50)
  }
  openModal(contact: any) {
    this.currentContact = contact
    this.modal.title = this.$t('contactBlock.steps.1.dialog_title')
    this.modal.show = true
  }
  closeModal() {
    this.currentContact = {}
    this.modal.show = false
  }
  setNameCustom(name:string) {
    console.log(this.contacts)
    this.contacts.push({
      isEditing: false,
      order: this.contacts.length,
      title: name,
      type: 'custom'
    })
  }
  deleteContact() {
    if (!Object.keys(this.currentContact).length) return
    const idx = this.contacts.findIndex((el: any) => {
      return this.currentContact.order == el.order
    })
    if (idx == -1) return
    this.contacts.splice(idx, 1)
    this.currentContact = {}
    this.modal.show = false
  }
  acceptEditing(contact: any) {
    contact.isEditing = false
    this.editCustom = false
  }
  declineEditing(contact: any) {
    contact.title = this.editingField
    this.editCustom = false
    this.editingField = ''
    contact.isEditing = false
  }
  replaceText(text: string) {
    if (!this.search) return text
    if (text.toLowerCase().includes(this.search.toLowerCase().trim())) {
      const regular = new RegExp(this.search, 'gi')
      return text.replace(regular, (string: string) => '<strong>' + string + '</strong>')
    }
    return text

  }
  async save() {
    if (this.loading) return
    const isPatchSuccess: boolean = await this.patchContacts({contacts: this.contacts})
    if (!isPatchSuccess) return
    this.normalizedContactFields.forEach((field: any) => field.checked = false)
    await this.fetchAndNormalizeContacts()
  }

  async fetchAndNormalizeContacts() {
    await this.fetchContacts()
    this.contacts = cloneDeep(this.getContacts)
    this.contacts = this.contacts.filter((contact:any) => contact.type != 'phone')
  }
  async fetchAndNormalizeContactFields() {
    await this.fetchFieldsList()
    this.normalizedContactFields = this.contactFields.map((el: any) => {
      return {...el, checked: false}
    })
    this.normalizedContactFields = this.normalizedContactFields
      .filter((field: any) => !this.DEFAULT_TYPES.includes(field.type))
  }

  protected async mounted() {
    await this.fetchAndNormalizeContacts()
    await this.fetchAndNormalizeContactFields()
    this.onContactsChanged()
  }
}
